import cookie from 'js-cookie';

/**
 * cookie helper methods
 */

export const setCookie = (key, value, { expires = 30 } = {}) => {
  if (process.browser) {
    const secure = process.env.NODE_ENV === 'development' ? false : true;
    const path = '/';
    const domain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
    const sameSite =
      process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' ? 'Lax' : 'None';

    cookie.set(key, value, {
      domain,
      expires,
      path,
      sameSite,
      secure,
    });
  }
};

export const removeCookie = (key) => {
  if (process.browser) {
    const path = '/';
    const domain = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

    cookie.remove(key, { path, domain });
  }
};

export const getCookie = (key, req) => {
  return process.browser ? getCookieFromBrowser(key) : getCookieFromServer(key, req);
};

const getCookieFromBrowser = (key) => {
  return cookie.get(key);
};

const getCookieFromServer = (key, req) => {
  if (!req?.headers?.cookie) {
    return undefined;
  }
  const rawCookie = req.headers.cookie.split(';').find((c) => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return undefined;
  }
  return rawCookie.split('=')[1];
};
